import { createGlobalStyle } from 'styled-components'

export const NotificationModalGlobalStyle = createGlobalStyle`
  .notification-modal-wrapper {
    font-family: "Inter", Noto Sans Display, sans-serif !important;

    .ant-modal {
      max-width: calc(100vw - 32px);
      font-family: "Inter", Noto Sans Display, sans-serif !important;
    }

    .ant-modal-content {
      border-radius: 16px !important;
      overflow: hidden !important;
      box-shadow: 0 20px 40px -8px rgba(15, 23, 42, 0.2) !important;
      border: 1px solid #eef2f6 !important;
      background: #ffffff !important;
      padding: 0 !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
    }

    .ant-modal-header {
      border: none !important;
      border-bottom: 1px solid #f1f5f9 !important;
      padding: 20px 24px !important;
      background: #ffffff !important;
    }

    .ant-modal-title {
      color: #0f172a !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      font-size: 18px !important;
      font-weight: 700 !important;
      letter-spacing: -0.01em !important;
      line-height: 26px !important;
      background: transparent !important;
    }

    .ant-modal-close {
      top: 16px !important;
      right: 18px !important;
    }

    .ant-modal-close-x {
      width: 36px !important;
      height: 36px !important;
      line-height: 36px !important;
      border-radius: 8px !important;
      transition: background 0.2s ease !important;
      color: #64748b !important;

      &:hover {
        background: #f1f5f9 !important;
        color: #0f172a !important;
      }
    }

    .ant-modal-body {
      background: #ffffff !important;
      padding: 24px !important;
      border-radius: 0 !important;
    }

    .ant-form-item-label > label {
      font-size: 14px !important;
      font-weight: 600 !important;
      color: #334155 !important;
      height: auto !important;
      margin-bottom: 6px !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
    }

    .ant-input {
      height: 40px !important;
      border-radius: 8px !important;
      border: 1px solid #e2e8f0 !important;
      padding: 0 14px !important;
      font-size: 14px !important;
      color: #0f172a !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      transition: all 0.2s ease !important;

      &:hover {
        border-color: #bae6fd !important;
      }

      &:focus,
      &.ant-input-focused {
        border-color: #9cd4fc !important;
        box-shadow: 0 0 0 2px rgba(112, 174, 251, 0.18) !important;
      }
    }

    .notification-editor-wrapper {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      overflow: hidden;
      transition: all 0.2s ease;

      &:hover {
        border-color: #bae6fd;
      }

      &:focus-within {
        border-color: #9cd4fc;
        box-shadow: 0 0 0 2px rgba(112, 174, 251, 0.18);
      }

      .ck.ck-toolbar {
        background: #f8fafc !important;
        border: none !important;
        border-bottom: 1px solid #e2e8f0 !important;
        padding: 6px 8px !important;
      }

      .ck.ck-content {
        min-height: 200px !important;
        max-height: 300px !important;
        overflow-y: auto !important;
        padding: 12px 16px !important;
        font-size: 14px !important;
        line-height: 1.6 !important;
        color: #334155 !important;
        border: none !important;

        &:focus {
          border: none !important;
          box-shadow: none !important;
        }
      }
    }

    .notification-dragger-upload {
      &.ant-upload.ant-upload-drag {
        background-color: #f8fafc !important;
        border: 1.5px dashed #cbd5e1 !important;
        border-radius: 8px !important;
        padding: 20px 16px !important;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
        cursor: pointer !important;

        &:hover {
          border-color: #9cd4fc !important;
          background-color: #eff8ff !important;
        }

        .ant-upload-drag-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .notification-modal-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 24px;
      padding-top: 18px;
      border-top: 1px solid #f1f5f9;

      .btn-cancel {
        height: 40px !important;
        min-width: 110px !important;
        border-radius: 8px !important;
        border: 1px solid #e2e8f0 !important;
        background: #ffffff !important;
        color: #475569 !important;
        font-family: "Inter", Noto Sans Display, sans-serif !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        transition: all 0.2s ease !important;

        &:hover {
          background: #f8fafc !important;
          border-color: #cbd5e1 !important;
          color: #0f172a !important;
        }
      }

      .btn-submit {
        height: 40px !important;
        min-width: 120px !important;
        border-radius: 8px !important;
        border-color: #1d68a5 !important;
        background: #1d68a5 !important;
        color: #ffffff !important;
        font-family: "Inter", Noto Sans Display, sans-serif !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        box-shadow: 0 2px 8px rgba(29, 104, 165, 0.2) !important;
        transition: all 0.2s ease !important;

        &:hover,
        &:focus {
          background: #155589 !important;
          border-color: #155589 !important;
          box-shadow: 0 4px 12px rgba(29, 104, 165, 0.3) !important;
        }
      }
    }
  }
`
